import { jsx as _jsx } from "preact/jsx-runtime";
import BasketItem from '@widgets/BasketList/BasketItem';
import { Wrapper } from './styles';
function BasketItems(props) {
    const { items } = props;
    console.log('items: ', items);
    return (_jsx(Wrapper, { children: items.map((item, idx) => (_jsx(BasketItem, { id: item.ProductId, description: item.Description, startDate: item.StartDate, sessionId: item.SessionId, duration: item.Duration, units: item.Units, priceBands: item.PriceBands, pageUrl: item.PageUrl, canEdit: item.canEdit, canDelete: item.canDelete }, idx))) }));
}
export default BasketItems;
